import moment = require('moment');
import { EventId } from '../../../models/eventId.model';

export class EventIdHelper {
  constructor() {

  }

  toEventId(value: string): EventId {
    if (!value) {
      return null
    }

    //  Remove any whitespace from raw value.
    let trimmedValue = value.trim()

    //  Validate using our rules for SEIDs.
    if (!this.isValid(trimmedValue)) {
      return null
    }

    //  Looks good, so split out the values from the pasted value into its parts.
    let set = trimmedValue.split(/-/)

    //  Create the proper formatted date from the date value.
    let parsedDate = moment(set[2], 'YYYYMMDD')

    //  Return the EventId instance.
    return new EventId(set[0], Number(set[1]), parsedDate.toDate())
  }

  isValid(value: string): boolean {
    //  1. If we have no value, it's not value.
    if (!value) {
      return false
    }

    //  2. If the pasted format doesn't match 3464029-6043503-20161121, it's not valid.
    if (!/^[0-9]{7}-[0-9]{1,12}-[0-9]{8}$/.test(value)) {
      return false
    }

    //  Split out the values from the pasted value into its parts.
    let set = value.split(/-/)

    //  3. If we don't have 3 fields, it's not valid.
    if (set.length !== 3) {
      return null
    }

    //  Create the proper formatted date from the date value.
    let parsedDate = moment(set[2], 'YYYYMMDD')

    //  4. If the date value could not be parsed, it's not valid.
    if (!parsedDate.isValid) {
      return null
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/helpers/event-search.eventIdHelper.ts